import { Container } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/RewardsSection.styled";
import Card from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/Card";
import { getCardStatus } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/utils/getCardStatus";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";

interface IRewardsSectionProps {
    packages: IPackage[];
    invitationCount: number;
}

const RewardsSection = ({ packages, invitationCount }: IRewardsSectionProps) => (
    <Container data-automation="rewards-section">
        {packages?.map((packageItem, index) => {
            const status = getCardStatus(index, packages, invitationCount);
            return (
                <Card
                    key={index}
                    cardIndex={index}
                    invitationCount={invitationCount}
                    packageItem={packageItem}
                    status={status}
                />
            );
        })}
    </Container>
);

export default RewardsSection;
